/* eslint-disable */
import axios from 'axios';
import { format } from 'date-fns';
import types from './mutations-types';

const actions = {
  async evolutionDailyNps({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/nps-evolution/daily`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          indicator: obj.indicator,
          groupId: obj.groupId,
          reportType: 'day',
          period: obj.period,
        },
      },
    );
    commit(types.SET_NPS_EVOLUTION, res.data);
  },
  async evolutionPeriodNps({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/nps-evolution/period`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          indicator: obj.indicator,
          groupId: obj.groupId,
          reportType: obj.reportType,
          period: obj.period,
        },
      },
    );
    commit(types.SET_NPS_EVOLUTION, res.data);
  },
  async evolutionPercentageDaily({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/percentil-evolution/daily`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          reportType: 'day',
          period: obj.period,
        },
      },
    );
    commit(types.PERCENTAGE_EVOLUTION, res.data);
  },
  async evolutionPercentagePeriod({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/percentil-evolution/period`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          reportType: obj.reportType,
          period: obj.period,
        },
      },
    );
    commit(types.PERCENTAGE_EVOLUTION, res.data);
  },
  async evolutionDailyAnswers({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/answer-evolution/daily`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          reportType: 'day',
          period: obj.period,
        },
      },
    );
    commit(types.SET_ANSWERS_EVOLUTION, res.data);
  },
  async evolutionPeriodAnswers({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/answer-evolution/period`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          reportType: obj.reportType,
          period: obj.period,
        },
      },
    );
    commit(types.SET_ANSWERS_EVOLUTION, res.data);
  },
  async evolutionDailyInvites({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/invites-evolution/daily`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          period: obj.period,
        },
      },
    );
    commit(types.SET_INVITES_EVOLUTION, res.data);
  },
  async evolutionPeriodInvites({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/invites-evolution/period`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          reportType: obj.reportType,
          period: obj.period,
        },
      },
    );
    commit(types.SET_INVITES_EVOLUTION, res.data);
  },
  async comparativeActions({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/metrics/actions/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          period: obj.period,
        },
      },
    );
    commit(types.SET_COMPARATIVE_ACTIONS, res.data);
  },
  async getCsat({ commit }, obj) {
    const res = await axios.get(`${process.env.API_ROOT}/reports/get-csat`, {
      headers: { 'x-access-token': obj.token },
      params: {
        companyId: obj.companyId,
        actionId: obj.actionId,
        //startDate: obj.startDate,
        //endDate: obj.endDate,
        page: obj.page,
        limit: obj.limit,
        ih1: obj.ih1,
        ih2: obj.ih2,
        metric: obj.metric,
        filter: obj.filter,
        period: obj.period,
        reportType: 'CSAT',
      },
    });
    commit(types.SET_CSAT_DATA, res.data);
  },
  async getLikert({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-ranking-generic`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          //startDate: obj.startDate,
          //endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          filter: obj.filter,
          period: obj.period,
          reportType: 'LIKERT',
        },
      },
    );
    commit(types.SET_LIKERT, res.data);
  },
  async getReviews({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-ranking-generic`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          //startDate: obj.startDate,
          //endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          sortDesc: obj.sortDesc,
          sortBy: obj.sortBy,
          filter: obj.filter,
          period: obj.period,
          reportType: 'REVIEWS',
        },
      },
    );
    commit(types.SET_REVIEWS, res.data);
  },
  async getEmotions({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-emotions`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          //startDate: obj.startDate,
          //endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          filter: obj.filter,
          period: data.period ? data.period : null,
          reportType: 'EMOTIONS',
        },
      },
    );
    commit(types.SET_EMOTION_DATA, res.data);
  },

  async getLikeDislike({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-like-dislike`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          //startDate: obj.startDate,
          //endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          filter: obj.filter,
          period: data.period ? data.period : null,
          reportType: 'LIKE/DISLIKE',
        },
      },
    );

    commit(types.SET_LIKE_DISLIKE_DATA, res.data);
  },

  async getReportCategories({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-report-categories`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          frequencyOption: obj.frequencyOption,
          period: obj.period,
        },
      },
    );

    commit(types.SET_REPORT_CATEGORIES, res.data);
  },
  async getReportTags({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-report-tags`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          page: obj.page,
          limit: obj.limit,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          period: obj.period,
        },
      },
    );
    commit(types.SET_REPORT_TAGS, res.data);
  },
  async getNpsIndicators({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/get-nps-by-indicators/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          period: obj.period,
        },
      },
    );

    commit(types.SET_INDICATORS, res.data);
  },
  async getEmotionsReportsData({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/reports/reports-emotions`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
          metric: obj.metric,
          groupId: obj.groupId,
          indicator: obj.indicator,
          indicatorValue: obj.indicatorValue,
          indicatorRange: obj.indicatorRange,
          period: obj.period,
        },
      },
    );

    commit(types.SET_REPORTS_EMOTIONS, res.data);
  },
  async setWordCloud({ commit }, obj) {
    const res = await axios.get(`${process.env.API_ROOT}/wordcloud`, {
      headers: { 'x-access-token': obj.token },
      params: {
        companyId: obj.companyId,
        actionId: obj.actionId,
        startDate: obj.startDate,
        endDate: obj.endDate,
        ih1: obj.ih1,
        ih2: obj.ih2,
        metric: obj.metric,
        groupId: obj.groupId,
        indicator: obj.indicator,
        indicatorValue: obj.indicatorValue,
        indicatorRange: obj.indicatorRange,
        period: obj.period,
      },
    });
    commit(types.SET_WORDCLOUD, res.data);
  },
  async setMapChart({ commit }, obj) {
    const { data: chartData } = await axios.get(
      `${process.env.API_ROOT}/reports/map-chart/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: { ...obj.params },
      },
    );

    return chartData;
  },
  async setMapChartMundi({ commit }, obj) {
    const { data: chartData } = await axios.get(
      `${process.env.API_ROOT}/reports/map-chart-mundi/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: { ...obj.params },
      },
    );

    return chartData;
  },
  async setFilterRankings({ commit }, filter) {
    commit(types.SET_FILTER_RANKINGS, filter);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/charts/actions.js